import { Pipe, PipeTransform } from '@angular/core';
import { ImportRequestStatus } from '../models/import-request-status';

@Pipe({
  name: 'importRequestStatus',
  pure: false,
  standalone: false
})
export class ImportRequestStatusPipe implements PipeTransform {
  transform(statusId: number): string {

    if (!statusId) {
      return '';
    }

    switch (statusId) {

      case ImportRequestStatus.FailedValidation:
        return 'Failed Validation';

      case ImportRequestStatus.Received:
        return 'Received';

      case ImportRequestStatus.Processed:
        return 'Processed';

      case ImportRequestStatus.NewRequestReceived:
        return 'New Request Received';

      default:
        return '';
    }
  }
}
